var User = function () {
    var self = this;
    self.UserId = 0;
    self.UserName = '';
    self.Password = '';
    self.FirstName = '';
    self.LastName = '';
    self.Address1 = '';
    self.Address2 = '';
    self.City = '';
    self.State = '';
    self.PostalCode = '';
    self.Phone = '';
    self.Email = '';
    self.CellPhone = '';
    self.Fax = '';
    self.WorkPhone = '';
    self.PersonId = '';
    self.Active = 1;
    self.Deleted = 0;
    self.PhotoId = 0;
    self.CreatedDate = new Date();
    self.LastLogInDateString = '';
    self.Creator = '';
    self.LastModifiedBy = '';
    self.Roles = [];
    self.Active = 'X';
    return self;
};
User.prototype.fullName = function() {
    return (this.LastName || '') + ', ' + (this.FirstName || '');
};
User.prototype.isAdmin = function() {
    var result = $.grep(this.Roles, function(r) { return r.RoleName === 'Adminstrator' && r.IsInRole; });
    return result.length > 0;
};
User.prototype.isInRole = function (role) { 
    role = role || ''; 
    var result = $.grep(this.Roles, function (r) { return  r.RoleName === 'Adminstrator' && r.IsInRole|| r.RoleName === role && r.IsInRole; });
    return result.length > 0;
};
angular.module('jcsfApp').value('User', User);